<template>
  <vonap-window
    :modal="true"
    :visible="value"
    transition="dialog-scale-transition"
    title="Change sending message"
    width="320px"
    height="217px"
    @success="refresh"
    @close="close"
  >
    <v-layout row justify-center>
      <v-card>
        <v-container grid-list-xl text-xs-center style="height:132px;width:302px">
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                v-model="sendingMessageName"
                label="Sending message name"
                required
                :rules="[v => !!v || 'Name is required!']"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <div class="spacer"></div>
          <v-btn block color="primary" @click="send">Save</v-btn>
          <v-btn block color="default" @click="close">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </vonap-window>
</template>
<script>
import axios from 'axios'
import notification from '@/helpers/notification'
import VonapWindow from '@/components/VonapWindow'

export default {
  name: 'ChangeSendingMessageConfirmForm',
  components: {
    VonapWindow,
  },
  props: {
    value: {type: Boolean},
    clientId: {type: Number},
    sendingMessageId: {type: Number},
    forwardOptionId: {type: Number},
    sendingMessageName: {type: String},
    sendSubject: {type: String},
    sendComments: {type: String},
  },
  methods: {
    refresh(e) {
      this.$emit('success', e)
    },
    async send() {
      const formData = {
        clientId: +this.clientId,
        sendingMessageId: +this.sendingMessageId,
        forwardOptionId: +this.forwardOptionId,
        name: this.sendingMessageName,
        subject: this.sendSubject,
        message: this.sendComments,
      }

      const response = await axios
        .post('/api/config/sendingMessage/setUndeliveredSendingMessage', formData)
        .catch(() => {
          notification('Some error', 'error')
          this.sending = false
        })

      if (response.status == 200) {
        notification('Sending message changed successfully!', 'info')
        this.refresh(response.data)
      }
    },
    close() {
      this.$emit('input', false)
    },
  },
}
</script>
